import React, { Component } from 'react';
import cx from 'classnames';
import TranslatedCopy from '../../../../intl/translated-copy';
import Pictogram from '../../pictogram';

class AmaiaHeader extends Component {
  render() {
    const { onClose, showChat } = this.props;
    const headerInfoClasses = cx('AmaiaChat-header-info', {
      'is-visible': showChat,
    });

    return (
      <div className='AmaiaChat-header'>
        <div className={ headerInfoClasses }>
          <Pictogram
            className='AmaiaChat-avatar-small'
            id='AmaiaLogoWelcome'
          />
          <TranslatedCopy
            className='AmaiaChat-title'
            copyID='AMAIA_ASSISTANT_TITLE'
            tagName='span'
          />
        </div>
        <button className='AmaiaChat-close' onClick={ onClose }>
          <span className='Icon Icon--xThin' />
        </button>
      </div>
    );
  }
}

export default AmaiaHeader;
